import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {InputNumber} from "primereact/inputnumber";
import {InputMask} from "primereact/inputmask";
import {Calendar} from "primereact/calendar";
import moment from "moment";

const EmployeecompensationFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    employee: Number(window.App.urlVars().employeeId),
    employment: Number(window.App.urlVars().employmentId),
    currency: process.env.REACT_APP_CURRENCY_DEFAULT
  });
  const [newFormData, setNewFormData] = useState({});
  const [frequencies, setFrequencies] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const payload = {
      ...data,
      ...formData,
      employee: Number(window.App.urlVars().employeeId),
      employment: Number(window.App.urlVars().employmentId),
    };
    if ((window.App.urlVars().compensationId) || (entity === 'employee-compensation' && id)) {
      apiCall('patch', '/api/v2/employee-compensation/' + (window.App.urlVars().compensationId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderTmpList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/employee-compensation', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderTmpList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/tmp/tmp/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  // const toolbarOptions = {
  //   container: [
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['image', 'formula'],
  //     [{'align': []}],

  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'color': []}, {'background': []}],
  //     ['clean']
  //   ]
  // }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().compensationId) || (entity === 'employee-compensation' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/employee-compensation/' + (window.App.urlVars().compensationId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
    apiCall('get', '/api/v2/dictionary/employee-compensation-frequency')
      .then(response => {
        setFrequencies(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('GET', '/api/v2/dictionary/currency')
      .then(response => {
        setCurrencies(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  return (
    <div className={"tmp-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="date_from" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="date_from"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldValidityStart')}</label>
                  <span className="">
                          <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"date_from"}
                                       mask={"9999-99-99"}
                                       placeholder={t('datePlaceholder')}
                                       value={formData.date_from}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           setFormData({
                                             ...formData,
                                             date_from: e.value
                                           })
                                           setNewFormData({ ...newFormData, date_from: e.value });
                                         }
                                       }}
                            />
                            <Calendar value={formData.date_from}
                                      locale="hu"
                                      format={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          date_from: moment.utc(e.value).local().format('YYYY-MM-DD')
                                        })
                                        setNewFormData({ ...newFormData, date_from: moment.utc(e.value).local().format('YYYY-MM-DD') });
                                      }}/>
                          </div>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="date_until" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="date_until"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldValidityEnd')}</label>
                  <span className="">
                          <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"date_until"}
                                       mask={"9999-99-99"}
                                       placeholder={t('datePlaceholder')}
                                       value={formData.date_until}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           setFormData({
                                             ...formData,
                                             date_until: e.value
                                           })
                                           setNewFormData({ ...newFormData, date_until: e.value });
                                         }
                                       }}
                            />
                            <Calendar value={formData.date_until}
                                      locale="hu"
                                      format={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          date_until: moment.utc(e.value).local().format('YYYY-MM-DD')
                                        })
                                        setNewFormData({ ...newFormData, date_until: moment.utc(e.value).local().format('YYYY-MM-DD') });
                                      }}/>
                          </div>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-12"}>
              <Field name="note" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="note"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldNote')}</label>
                  <span className="p-d-block">
                      <InputText id="note" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     note: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     note: e.target.value
                                   })
                                 }}
                                 value={formData.note}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="frequency" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="frequency"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldFrequency')}</label>
                  <span className={"p-d-block"}>
                      <Dropdown {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    frequency: e.target.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    frequency: e.target.value
                                  })
                                }}
                                value={formData.frequency?.id || formData.frequency}
                                options={window.App.sortDropdownOptions(frequencies, "value")}
                                optionLabel="value"
                                optionValue="key"
                                id={"frequency"}
                                emptyMessage={t('noFrequencyYet')}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="base_pay_amount" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="base_pay_amount"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldBasePayAmount')}</label>
                  <span className="p-d-block">
                      <InputNumber id="base_pay_amount" {...input}
                                   onValueChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       base_pay_amount: e.value
                                     })
                                     setNewFormData({
                                       ...newFormData,
                                       base_pay_amount: e.value
                                     })
                                   }}
                                   value={formData.base_pay_amount}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="currency" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="currency"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCurrency')}</label>
                  <span className={"p-d-block"}>
                              <Dropdown {...input}
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            currency: e.target.value
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            currency: e.target.value
                                          })
                                        }}
                                        value={formData.currency}
                                        options={window.App.sortDropdownOptions(currencies, "key")}
                                        optionLabel="key"
                                        optionValue="key"
                                        id={"currency"}
                                        emptyMessage={t('noCurrencyYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'tmp' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(EmployeecompensationFormComponent);
